import { IIncidentStatus } from '../interfaces/IIncidents';

export const allStatus: IIncidentStatus[] = ['acknowledged', 'resolved', 'suppressed', 'triggered'];
